import AddIcon from '@material-ui/icons/Add';
import { Box, Fab, FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import { useEffect, useState } from "react";
import NumberInputField from "../ui/NumberInputField";
import { PocketSpringZoneModel } from '../../api/OrderSpringApi';
import { SpringMaterial } from '../../api/SpringMaterialApi';
import { SpringMaterialCustomerPrice } from '../../api/SpringMaterialCustomerPriceApi';

interface Properties {
  readonly materials: SpringMaterial[];
  readonly materialPrices: SpringMaterialCustomerPrice[];
  readonly addZone: (zone: PocketSpringZoneModel) => void;
}

const useStyles = makeStyles(theme => ({
  materialSelect: {
    width: 320,
    marginRight: theme.spacing(2)
  },
  inputField: {
    width: 130
  },
  zoneActionButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }
}));

const PocketSpringZoneDeclaration = ({ materials, materialPrices, addZone }: Properties) => {
  const classes = useStyles();
  const [initialMaterialId, setInitialMaterialId] = useState<number>();
  const [userSelectedMaterial, setUserSelectedMaterial] = useState<SpringMaterial|null>(null);
  const [length, setLength] = useState<number>();

  const handleMaterialChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedMaterial = event.target.value as SpringMaterial;
    setUserSelectedMaterial(selectedMaterial);
  };

  const handleAddZone = () => {
    if (userSelectedMaterial !== null && length !== undefined) {
      addZone({
        material: userSelectedMaterial,
        length: length
      });
    }
  };

  const isAddButtonDisabled = () => {
    return userSelectedMaterial === undefined || userSelectedMaterial == null || length === undefined;
  };

  const renderMaterialMenuItem = (material: SpringMaterial) => {
    const materialPrice = getMaterialPrice(material);
    return (
      <MenuItem key={material.id} value={material as any}>
        {material.name} ({material.thickness} mm) : {materialPrice === undefined ? '?' : materialPrice.unitPrice} zł
      </MenuItem>
    );
  };

  const getMaterialPrice = (material: SpringMaterial) => materialPrices[material.id];

  useEffect(() => {
    if (materials && initialMaterialId) {
      const selectedMaterial = materials.find(item => item.id === initialMaterialId);
      setUserSelectedMaterial(selectedMaterial || null);
    }
  }, [materials, initialMaterialId]);

  return <Box display='flex' flexDirection='row'>
    <FormControl className={ classes.materialSelect }>
      <InputLabel>Materiał</InputLabel>
      <Select value={ userSelectedMaterial || null } onChange={ handleMaterialChange }>
        { materials
          .filter(material => getMaterialPrice(material) !== undefined)
          .sort((material, anotherMaterial) => material.name.localeCompare(anotherMaterial.name))
          .map(renderMaterialMenuItem)
        }
      </Select>
    </FormControl>
    <NumberInputField
      classes={ classes }
      label='Długość'
      initialValue={ length }
      onValueChange={ setLength }
    />
    <Fab
        className={ classes.zoneActionButton }
        aria-label='add'
        color='primary'
        onClick={ handleAddZone }
        size='small'
        disabled={ isAddButtonDisabled() }
      >
        <AddIcon />
      </Fab>
  </Box>
};

export default PocketSpringZoneDeclaration;